export default "__VITE_ASSET__pUhUo0lK__"